// extracted by mini-css-extract-plugin
module.exports = {"assetList":"AssetList-module--assetList--1O0Hp","empty":"AssetList-module--empty--3FlGQ"};